import { render, staticRenderFns } from "./EventSection.vue?vue&type=template&id=485362aa&scoped=true&"
import script from "./EventSection.vue?vue&type=script&lang=ts&"
export * from "./EventSection.vue?vue&type=script&lang=ts&"
import style0 from "./EventSection.vue?vue&type=style&index=0&id=485362aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485362aa",
  null
  
)

export default component.exports